// extracted by mini-css-extract-plugin
module.exports = {"document-infobar":"document-infobar_document-infobar__3s1L6"};